// Tour steps that target `properties-*` fields dispatch
// `ensure:block-selected` when they run. Auto-select the first visible
// block if none is selected so the properties-panel actually renders
// the fields the tour wants to highlight.

import { useEffect, useRef } from 'react';
import { useWorkflow } from '@/contexts/WorkflowContext';
import { subscribeOnboardingEvent } from '@/components/onboarding/uiAdapter';

export function useTourBlockAutoSelect({ viewOnly, setSelectedGroupId }: {
  viewOnly: boolean;
  setSelectedGroupId: (id: string | null) => void;
}) {
  const { blocks, selectedBlockId, setSelectedBlockId } = useWorkflow();

  const blocksRef = useRef(blocks);
  useEffect(() => { blocksRef.current = blocks; }, [blocks]);

  const selectedBlockIdRef = useRef(selectedBlockId);
  useEffect(() => { selectedBlockIdRef.current = selectedBlockId; }, [selectedBlockId]);

  useEffect(() => {
    if (viewOnly) return;
    return subscribeOnboardingEvent((event) => {
      if (event.name !== 'ensure:block-selected') return;
      if (selectedBlockIdRef.current) return;
      const first = blocksRef.current[0];
      if (first) {
        setSelectedBlockId(first.id);
        setSelectedGroupId(null);
      }
    });
  }, [viewOnly, setSelectedBlockId, setSelectedGroupId]);
}
